import { inject, Injectable, InjectionToken } from '@angular/core';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  provideChildTranslateService,
  provideMissingTranslationHandler,
} from '@ngx-translate/core';

type TranslationDefaults = { [key: string]: any };

// const traverse = (path: string[], tree: TranslationDefaults) => {
//   const [cur, ...rest] = path;
//   if (typeof tree[cur] === 'string') {
//     return tree[cur];
//   } else if (tree[cur]) {
//     return traverse(rest, tree[cur]);
//   } else {
//     return false;
//   }
// };

const flattenObject = (
  obj: Record<string, string | Record<string, any>>,
  prefix = '',
): Record<string, string> =>
  Object.entries(obj).reduce(
    (acc, cur) =>
      typeof cur[1] === 'string'
        ? { ...acc, [prefix ? prefix + '.' + cur[0] : cur[0]]: cur[1] }
        : {
            ...acc,
            ...flattenObject(cur[1], prefix ? prefix + '.' + cur[0] : cur[0]),
          },
    {} as Record<string, string>,
  );

const DefaultTranslations = new InjectionToken<TranslationDefaults>(
  'component.translation.defaults',
);

@Injectable()
export class DefaultsTranslationHandler implements MissingTranslationHandler {
  #translations = flattenObject(inject(DefaultTranslations));

  handle(params: MissingTranslationHandlerParams): string {
    return (
      this.#translations[
        params.translateService.getCurrentLang() + '.' + params.key
      ] ?? params.key
    );
  }
}

export const provideComponentDefaultTranslations = (translations: {
  [language: string]: TranslationDefaults;
}) => [
  { provide: DefaultTranslations, useValue: translations },
  provideChildTranslateService({
    missingTranslationHandler: provideMissingTranslationHandler(
      DefaultsTranslationHandler,
    ),
  }),
];
